import { render, staticRenderFns } from "./SiteDashboard.vue?vue&type=template&id=74bd1dfb&"
import script from "./SiteDashboard.vue?vue&type=script&lang=js&"
export * from "./SiteDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74bd1dfb')) {
      api.createRecord('74bd1dfb', component.options)
    } else {
      api.reload('74bd1dfb', component.options)
    }
    module.hot.accept("./SiteDashboard.vue?vue&type=template&id=74bd1dfb&", function () {
      api.rerender('74bd1dfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/sites/SiteDashboard.vue"
export default component.exports